// extracted by mini-css-extract-plugin
export default {"iconMS":"IconMS_iconMS__zv+oz","fontsLoaded":"IconMS_fontsLoaded__QyFCR"};